export interface CounselorPersonalDataFormValues {
  userCode: string;
  team: string | null;
  isTeamLeader: boolean | null;
  // Text fields hold "" rather than null so an emptied field compares equal to an empty initial value.
  mobileNumber: string;
  phoneExtension: string;
}

export const MAX_USER_CODE_LENGTH = 20;
export const MAX_MOBILE_NUMBER_LENGTH = 50;
export const MAX_PHONE_EXTENSION_LENGTH = 20;

/** Character set the counselor code is restricted to, mirroring the backend's counselor user-code rule. */
export const UserCodePattern = /^[A-Za-z0-9]+$/;
